import DSlider from './src';

DSlider.install = Vue => {
  Vue.component('DSlider', DSlider);
};

export default DSlider;
